<div id="map-detail">
    <iframe
  width="400"
  height="150"
  frameborder="0" style="border:0;border-radius: 10px;z-index: 1100;"
  src="https://www.google.com/maps/embed/v1/place?key=AIzaSyD6JumlPFLkyQHY2TGrGOnebR48Wk4Iw3w
    &q=R.P.D.A.V. Public School,5V78+6QM, SH 7, Mohalla Saidanwala, Shahbad, Haryana 136135" allowfullscreen>
</iframe>
</div>